// extracted by mini-css-extract-plugin
module.exports = {"root":"Collapsible_root__ki8xM","inner":"Collapsible_inner__LvGaD"};